import React from 'react';
import { Box, Skeleton } from '@mui/material';

export const AriaChatListSkeleton = ({ rows = 6 }) => (
  <Box sx={{ px: 1, pb: 1 }}>
    {Array.from({ length: rows }).map((_, index) => (
      <Box
        key={`aria-chat-skel-${index}`}
        sx={{
          display: 'flex',
          gap: 1.25,
          alignItems: 'flex-start',
          px: 1.25,
          py: 1.25,
          mb: 0.5,
        }}
      >
        <Skeleton variant="circular" width={40} height={40} animation="wave" />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1, mb: 0.75 }}>
            <Skeleton variant="rounded" width="42%" height={14} animation="wave" />
            <Skeleton variant="rounded" width={36} height={12} animation="wave" />
          </Box>
          <Skeleton variant="rounded" width="88%" height={12} animation="wave" sx={{ mb: 0.75 }} />
          <Box sx={{ display: 'flex', gap: 0.5 }}>
            <Skeleton variant="rounded" width={64} height={18} animation="wave" />
            <Skeleton variant="rounded" width={72} height={18} animation="wave" />
          </Box>
        </Box>
      </Box>
    ))}
  </Box>
);

export const AriaMessagesSkeleton = ({ rows = 5 }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, py: 0.5 }}>
    {Array.from({ length: rows }).map((_, index) => {
      const alignEnd = index % 2 === 1;
      return (
        <Box
          key={`aria-msg-skel-${index}`}
          sx={{
            display: 'flex',
            flexDirection: alignEnd ? 'row-reverse' : 'row',
            gap: 1.25,
            alignItems: 'flex-start',
          }}
        >
          <Skeleton variant="circular" width={36} height={36} animation="wave" />
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              display: 'flex',
              flexDirection: 'column',
              alignItems: alignEnd ? 'flex-end' : 'flex-start',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                gap: 1,
                mb: 0.75,
                flexDirection: alignEnd ? 'row-reverse' : 'row',
              }}
            >
              <Skeleton variant="rounded" width={88} height={12} animation="wave" />
              <Skeleton variant="rounded" width={40} height={12} animation="wave" />
            </Box>
            <Skeleton
              variant="rounded"
              animation="wave"
              width={`${58 + ((index * 11) % 28)}%`}
              height={52}
              sx={{ borderRadius: alignEnd ? '12px 12px 4px 12px' : '12px 12px 12px 4px' }}
            />
          </Box>
        </Box>
      );
    })}
  </Box>
);
